import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ArrowDropDown } from "@mui/icons-material";
import noData from "../../../assets/images/NodataAvailable.svg";
import SearchBox from "../../../components/components-library/searchbox";

const CustomDropdown = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  className,
  required = false,
  isList = false,
  ulHeight = "",
  showBorder = true,
  disabled = false,
  valueColor = "",
  isMarginTop = false,
  isSearchRequired = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    const handleScroll = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside, true);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const handleOpen = () => {
    if (disabled) return;

    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }

    setSearchTerm("");
    setIsOpen((prev) => !prev);
  };

  const filteredOptions = options?.filter((option) => {
    if (isList) {
      return option
        ?.toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    }

    return option?.label
      ?.toString()
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());
  });

  return (
    <div className={`relative w-full ${className}`}>
      {label && (
        <label className="fs-14 font-semibold block ">
          {label} <span className="color-red">{required && "*"}</span>
        </label>
      )}

      <div
        ref={triggerRef}
        className={`relative fs-14 w-full px-2 py-1.5 h-[39px] ${isMarginTop ? "mt-[0.7rem]" : "mt_8"}  br-10 flex items-center justify-between transition-all ${
          showBorder ? "border br-10 shadow-md" : ""
        }
          ${
            disabled
              ? "bg-gray-100 text-gray-500 cursor-not-allowed"
              : "bg-white cursor-pointer"
          } ${valueColor}`}
        onClick={handleOpen}
      >
        <span>
          {value !== undefined && value !== null ? (
            <div className="flex gap-1">
              {options?.find((o) => o?.value === value)?.icon ? (
                <img
                  src={options?.find((o) => o?.value === value)?.icon}
                  alt=""
                  className="w-4"
                />
              ) : (
                ""
              )}
              {options?.find((o) => o?.value === value)?.label}
            </div>
          ) : (
            placeholder || "-Select-"
          )}
        </span>
        <ArrowDropDown
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </div>

      {isOpen &&
        createPortal(
          <ul
            ref={dropdownRef}
            className={`dropdown-portal absolute bg-white border br-10 shadow-lg z-[1000] ${ulHeight}`}
            style={{
              position: "absolute",
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              width: dropdownPosition.width,
              maxHeight: 220,
              overflowY: "auto",
            }}
          >
            {options?.length > 1 && isSearchRequired && (
              <li className="sticky top-0 bg-white p-2 border-b z-10">
                <SearchBox
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search..."
                  onMouseDown={(e) => e.stopPropagation()}
                />
              </li>
            )}

            {filteredOptions?.length > 0 ? (
              filteredOptions?.map((option) => (
                <li
                  key={option.value}
                  className="p-2 cursor-pointer fs-14 hover:bg-gray-100"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    if (isList) {
                      onChange(option);
                    } else {
                      onChange(option.value);
                    }
                    setIsOpen(false);
                  }}
                >
                  {isList && option}
                  <div className={`flex ${option.icon ? "gap-1" : ""} `}>
                    {option.icon ? (
                      <img src={option.icon} alt="" className="w-4" />
                    ) : (
                      ""
                    )}

                    {!isList && option.label}
                  </div>
                </li>
              ))
            ) : (
              <li className="p-2 fs-14 flex justify-center items-center">
                <img src={noData} className="w-25 h-25" />
              </li>
            )}
          </ul>,
          document.body,
        )}
    </div>
  );
};

export default CustomDropdown;
